export default {
  headerContent: {
    title: 'Generali Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Hayatın her zaman belirsizliklerine karşı önlem almak zordur. Çünkü beklenmedik anlarda bu talihsizlikler kendisini gösterebilir ve oluşan durum sonucunda sıkıntıya düşebiliriz. Özellikle maddi konularda herhangi bir güvencemiz bulunmuyorsa kaza anlarını atlatmak oldukça zor olabilir. Ferdi kaza sigortası ile bu durumların üstesinden gelmek mümkündür.',
        '<strong>Generali ferdi kaza sigortası</strong>, sigortalı kişinin kendi iradesi dışında meydana gelen ani ve beklenmedik kazalara karşı güvence vermektedir. Her an karşılaşılabilecek kazalara karşı sunduğu geniş teminatlar ile kaza durumlarına karşı sigortalı kişinin kendisine ya da yakınlarına tazminat ödenen sigorta türüdür.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası geniş bir yelpazede sunulmuştur çünkü karşılaşılacak kazalar oldukça fazladır. Trafik, ev veya işe bağlı kazaların yanı sıra zehirlenme, sokulma, ısırılma gibi durumları da kapsayan bu sigorta ile kişi teminatlar seçerek kendisine en uygun poliçeyi hazırlamaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Gündelik yaşamda karşılaşma olasılığı yüksek olan durumlara istinaden hazırlanan ana teminatlar, sigortalı kişinin vefatını ya da sürekli maluliyet durumunu temel alarak sunulmaktadır. Bu kapsamda;',
          subList: [
            '<strong>Kaza sonucu vefat;</strong> sigortalı kişinin, poliçede belirlenmiş kazalar sonucu derhal ya da olayı takiben 1 yıl içerisinde vefat etmesi halinde kanuni varislerine tazminat ödemesi yapılmaktadır. 16 yaşından küçük kimseler için bu teminat cenaze masraflarını karşılamaktadır.',
            '<strong>Kaza sonucu sürekli maluliyet;</strong> sigortalı kişinin, poliçede belirlenmiş kazalar sonucu derhal ya da olayı takiben 2 yıl içerisinde, doktor raporu ile kesinleşmiş ve artık tedavisi bitmiş olması kaydıyla tam maluliyet halinde poliçede belirlenmiş tazminat ödemesi yapılmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Güvenceler ana teminat kapsamında yetersiz bulunuyorsa isteğe bağlı ek teminatlar ile poliçenin kapsamı diğer kaza durumlarını da içine alacak şekilde genişletilmektedir. Bu kapsamda;',
          subList: [
            '<strong>Terör teminatı;</strong> diğer sigorta şirketlerinden farklı olarak sunulan bu teminat ile 3713 sayılı kanun kapsamına giren eylemlerden ya da sabotajdan ötürü sigortalı kişinin kazaya uğraması sonucunda tazminat ödemesi yapılmaktadır. ',
            '<strong>Deprem teminatı;</strong> deprem ve depreme bağlı olarak sigortalı kişinin kazaya uğraması sonucunda tazminat ödemesi yapılmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortası Teminat Dışı Durumlar Nelerdir?',
      content: [
        {
          paragraph:
            'Generali Sigorta ferdi kaza sigortası teminat dışı durumlar poliçede detaylı olarak belirtilmiştir. Hangi durumların kaza olarak sayılmadığını bilmek, sigortanın da hangi durumlarda ödeme yapmayacağını bilmek anlamına gelir. Böylece kaza sayılmayan durumlar şöyle sıralanabilir;',
          subList: [
            'Her türlü savaş ve savaşa bağlı olarak oluşan hasarlar,',
            'Açık deniz avcılığı ve yüksek yer avcılığı,',
            'Motosiklet kullanımı – kask kullanımı önemli değildir,',
            'Nükleer maddelerinin sebep olduğu hasarlar,',
            'Suç işlerken oluşan hasarlar,',
            'Sigortalı kişinin kasıtlı olarak kendisini tehlikeye attığı durumlar,',
            'Hastalık ve hastalığa bağlı olarak gelişen durumlar,',
            'İntihar ya da intihara teşebbüs,',
            'Ek teminat yoksa deprem ve diğer doğal afetler,',
            'Havada yolcu sıfatı dışındaki eylemler,',
            'Her türlü spor müsabakası ve sürat yarışları'
          ]
        },
        {
          paragraph:
            'Sonucunda oluşan hasarlar kaza olarak sayılmayıp teminat dışı tutulmaktadır. Teminat dışı kalan durumlar, duruma göre daha genişletilebilmektedir. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortası Teminat Bedelleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası teminat bedelleri sigortalının yaşı, mesleği ve seçtiği teminatlara göre belirlenmektedir. Bunun yanında ek araçlar da kullanılmaktadır. Örneğin deprem teminatının seçilmesi durumunda eğer kişi riskli deprem bölgesinde yaşıyorsa prim ödemesi yüksek olacaktır, aynı şekilde deprem riski düşük bölgede yer alan birisi ise daha düşük primler ödeyecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Güvenceleri Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası neredeyse her kaza durumuna karşılık güvenceler sunmaktadır. Özellikle kazaların sık yaşandığı trafik, ev ve iş gibi alanları ve daha özel bölümlere karşılık güvenceleri bulunmaktadır. Özellikle trafik sigortası, bilindiği gibi sadece karşı tarafında hasarını karşıladığı için ferdi kaza sigortası kapsamında sigortalı kişinin masraflarının ödenmesi, karşılanması büyük bir avantaj olarak belirmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Sunmuş olduğu güvenceler ve vergi indirimi, ek hizmetler ile Generali Sigorta ferdi kaza sigortası avantajlı bir konuma sahiptir. Aynı zamanda sigortanın sadece sigorta sahibini değil yakınları da kapsıyor oluşu belirtmeye değen bir başka husustur.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortası İçin Gerekli Bilgiler / Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Sigorta başvuru sırasında gereken belgeler doğru olarak hazırlanmalıdır.  Başvuru için ilk aşamada kimlik yeterli olmaktadır. Ancak özel durumlara istinaden ek belgeler talep edilebilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası isteğe bağlı sigorta türüdür. Zorunlu olmamasına rağmen yaşamın barındırdığı risklere karşılık zorunlu olarak görülmesi gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Şartları Nelerdir?',
      content: [
        {
          paragraph:
            'Sigorta birkaç konuda şartların yerine getirilmesini ister. Bu genel şartlar; sigortalı kendi poliçesini bir başkasına devredemez, vefatı halinde yasal mirasçıları ya da hukuksal olarak tespit edilemeyen kimselere tazminat ödemesi yapılmaz, ödemelerin düzgün yapılması ve yalan beyanda bulunulmaması da şartlar arasındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            '18 ile 60 yaş arasında olan herkes bu sigortadan yararlanabilmektedir. Poliçe yenilemeleri ile 65 yaşına kadar sigortalı kalınmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortasında Yararlanabileceğiniz Hizmetler Nelerdir?',
      content: [
        {
          paragraph:
            'Sunulan ek hizmetler ile sigortalı olmanız durumunda anahtar, tesisat, araç kiralama, çilingir, araç kurtarma, konaklama, otel rezervasyonu, bagaj takibi, şehir rehberi, fatura ödenmesi, tıbbi destek, acil yardım gibi konularda hizmet alabilirsiniz. Bu hizmetlerin her biri için yıllık kullanım süresi belirlenmiştir ve bazı hizmetler için katılım payı gerekebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yaptırmak için gereken belgeler ile başvuruda bulunmak yeterlidir. Kimliğin yanı sıra istenecek diğer belgelerin de doğru olarak sunulması önem taşır. Belgelerin sunulmasından sonra teminatlar ve tazminat tutarı belirlenip prim ödemeleri hesaplanacaktır. İlk primin ödenmesine müteakip sigorta başlamış olacaktır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortasında Vergi İndirimi Var Mıdır?',
      content: [
        {
          paragraph:
            'Generali Sigorta ferdi kaza sigortasında vergi indirimi sunulmaktadır. Her vergi mükellefi, çalıştığı kurum ya da kuruluşun muhasebesine poliçesini sunması halinde yüzde 15’i bulan oranlarda vergi indiriminden yararlanabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortasında Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası bir sağlık sigortası olmadığı için hastalık ve sağlık ile ilgili durumları kapsamaz. Aynı şekilde kasıtlı olarak kişinin kendisine vereceği durumları da kaza olarak saymaz. Ayrıca poliçenin geçerli olması için prim ödemelerine ve yenileme süresine de dikkat edilmelidir. Poliçe 1 yıllık olarak düzenlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Hesaplaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Kişinin yaşı ve mesleği ile seçtiği teminatlar temel alınarak sigorta hesaplaması yapılabilmektedir. Bu yüzden en iyi fiyatı ancak teklif sonunda öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortası Prim Ödeme Koşulları Nelerdir?',
      content: [
        {
          paragraph:
            'Primler Türk Lirası ya da döviz üzerinden aylık ya da yıllık seçenekler ile ödenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            '<strong>Generali Sigorta ferdi kaza sigortası fiyatları</strong> yıllık ve kişilerin durumlarına – tercihlerine bağlı olarak değişkenlik gösterdiği için teklif alınması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Ferdi Kaza Sigortası Fiyat Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Fiyat teklifini internet sitesi ve çağrı merkezi üzerinden alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko uzmanlarından fiyat teklifi alabilmek için 7 gün 24 saat ulaşım sağlayacağınız çağrı merkezi ve internet başvuru formu bulunmaktadır. Sizden istenecek bilgileri doğru olarak girmeniz önemlidir.',
          subList: null
        },
        {
          paragraph:
            '<strong>Generali Sigorta ferdi kaza sigortası fiyat teklifi</strong> almak için internet sitemizden sigorta uzmanlarımıza bilgilerinizi ileterek kolayca fiyat teklifi alabilirsiniz. Ferdi kaza sigortası fiyat teklifi için başvuru formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    }
  ]
}
